import { createApp } from 'vue'
import { HttpClient } from './lib/http-client.js'
import { needsProp } from './lib/needs-prop.js'

/**
 * Dynamically loads Vue components.
 */
export const Ienavi = {
  /**
   * ページ内で必要なVueComponentをマウントします
   *  - VueComponentは vue_tag helper で作成されたElementにマウントされます
   *    (※ app/helpers/application_helper.rb#vue_tag)
   *  - VueComponentで httpClient / csrfToken が必要な場合は、
   *.   上記の名前で Component の props に設定すると自動で追加します
   * @param {object} context - { 'path/to/component.vue': { default: VueComponent }, ... }
   * @returns {void}
   */
  start: context => {
    const vueOptions = {}

    Object.keys(context).forEach(key => {
      const name = key.match(/.+\/(.+)\.(vue|ts)$/)[1]
      vueOptions[name] = context[key].default
    })

    window.addEventListener('load', () => {
      const mountTargets = Array.from(document.querySelectorAll('[data-vue]'))
      const origin = window.location.origin

      mountTargets.forEach(el => {
        const vueOption = Object.assign(vueOptions[el.dataset.vue], { el })
        const { csrfToken, ...props } = el.dataset.props ? JSON.parse(el.dataset.props) : {}

        if (needsProp(vueOption, 'httpClient')) {
          props.httpClient = new HttpClient({ origin, headers: { 'X-CSRF-Token': csrfToken } })
        }

        const vm = createApp(vueOption, props)
        vm.mount(el)
      })
    })
  }
}
